import { render, staticRenderFns } from "./QuestionsPage.vue?vue&type=template&id=efb685fa&"
import script from "./QuestionsPage.vue?vue&type=script&lang=js&"
export * from "./QuestionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports